<script setup lang="ts">
import { useDeliveryAddressPrompt } from '../model/useDeliveryAddressPrompt'

// Стартовый промпт «Укажите адрес для заказа» (Dodo-стайл): состояние и поведение —
// в композабле, представление — общая шторка UiStartPromptSheet.
const { isOpen, chooseAddress, dismiss } = useDeliveryAddressPrompt()
</script>

<template>
  <UiStartPromptSheet
    :open="isOpen"
    icon="i-heroicons-map-pin-20-solid"
    subtitle="Не знаем, где вы"
    title="Укажите адрес для заказа"
    primary-label="Указать"
    @primary="chooseAddress"
    @dismiss="dismiss"
  />
</template>
